<!-- libs/core/shell/src/lib/layout/shell-header/shell-header.component.html -->
<header
  class="l-topbar"
  [class.l-topbar--visible]="compactVisible"
  [class.l-topbar--hidden]="!compactVisible"
  role="banner"
>
  <div class="l-container l-topbar__row">
        <a
      class="c-brand"
      href=""
      (click)="onBrandClickToLogin($event)"
      aria-label="Ir para o início"
    >
        <img
        class="c-brand__mark"
        [src]="brand.mascoteLogo()"
        [alt]="brand.appName() ? brand.appName() + ' Logo' : 'MenuHub'"
        width="100"
        height="100"
      />
      <span class="c-brand__name">
        {{ brand.appName() || 'Menu Hub' }}
      </span>
    </a>
    @if(showButtons) {
      <div class="l-topbar__actions">
        <button class="c-iconbtn" type="button" (click)="openCart()" aria-label="Abrir carrinho">
              <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M6.6 6h14.1l-1.7 8.3a2 2 0 0 1-2 1.6H9a2 2 0 0 1-2-1.6L5.1 3.8A1.5 1.5 0 0 0 3.6 2.6H2.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.2 21a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4ZM17.3 21a1.2 1.2 0 1 0 0-2.4 1.2 1.2 0 0 0 0 2.4Z" fill="currentColor"/>
            </svg>
          @if (cartCount() > 0) {
            <span class="c-badge">{{ cartCount() }}</span>
          }
        </button>
  
        <button class="c-iconbtn" type="button" (click)="openConfig()" aria-label="Configurações">
              <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 15.2a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Z" fill="none" stroke="currentColor" stroke-width="1.8"/>
              <path d="M19.3 12a7.7 7.7 0 0 0-.1-1l2-1.4-2-3.5-2.4.8a7.7 7.7 0 0 0-1.7-1l-.4-2.5H9.3L8.9 6a7.7 7.7 0 0 0-1.7 1l-2.4-.8-2 3.5 2 1.4a7.7 7.7 0 0 0 0 2l-2 1.4 2 3.5 2.4-.8a7.7 7.7 0 0 0 1.7 1l.4 2.5h5.4l.4-2.5a7.7 7.7 0 0 0 1.7-1l2.4.8 2-3.5-2-1.4c.1-.3.1-.7.1-1Z" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
  
        <button class="c-iconbtn" type="button" (click)="toggleTheme()" aria-label="Alternar tema" data-theme-toggle >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 18.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13Z" fill="none" stroke="currentColor" stroke-width="1.8"/>
              <path d="M12 2v2.3M12 19.7V22M22 12h-2.3M4.3 12H2M19.1 4.9l-1.6 1.6M6.5 17.5 4.9 19.1M19.1 19.1l-1.6-1.6M6.5 6.5 4.9 4.9" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/>
            </svg>
        </button>
      </div>
    }
  </div>
</header>